<style lang="less">
.pdf-export{
  .markdown-body h1{
    margin-top:0 !important;
  }
}
</style>
<template>
    <div style="height:100%;overflow:hidden;position:relative;">
      <div class="flex-wrap flex-between" style="height:50px;padding:0 10px;background:linear-gradient(to right,#fff,var(--border));">
        <div class="flex-wrap split5"> 
          <div class="flex-wrap" style="white-space:nowrap">平台 <Select v-model="platform" style="margin-left:5px;width:120px;" @on-change="getProjectData()">
            <Option v-for="p in platforms" :value="p.key" :key="p.key">{{ p.name }}</Option>
            </Select></div>
          <Select 
            v-model="selectedProjects" 
            multiple 
            filterable 
            clearable
            placeholder="选择项目（不选表示所有在建项目）"
            style="width:400px;"
            :max-tag-count="2"
            @on-change="getProjectData()"
            >
            <Option v-for="p in projects" :value="p.id" :key="p.id" :label="p.name">
              {{ p.name }}
              <Tag>{{ p.finished?'已完成':'进行中' }}</Tag>
              <Tag v-if="p.group">{{ p.group}}</Tag>
            </Option>
          </Select>
        </div>
        <div class="flex-wrap flex-right">
        <Button @click="CopyToClip" v-if="aiText" type="info">复制数据</Button>
        <Button @click="CopyAttachmentsToClip" v-if="(images.length > 0 || files.length > 0)">复制附件信息</Button>
      </div>

      </div>
      <div style="height:calc(100% - 50px);border-top:1px solid var(--border);padding:10px;overflow:hidden;display:flex;flex-direction:column;">
        <div style="border:1px dashed var(--border);flex:1;min-height:0;display:flex;flex-direction:column;">
          <Input
            type="textarea"
            v-model="userText"
            :rows="6"
            style="width:100%;display:block"
            placeholder="请输入您的需求，或点击下方按钮应用预设提示词"
          />
          <div class="flex-wrap flex-between" style="align-items:center;">
            <div class="flex-wrap" style="align-items:center;">  
              <Button
                style="margin:10px 0;"
                @click="getProjectData">获取数据</Button>
              <Button type="default" size="small" style="margin-left:8px;" @click="applyPresetPrompt">应用预设：纳入通用模板分析</Button>
              文本长度:{{ aiText.length }}
            </div>
           <div class="flex-wrap">
            <Button @click="CopyToClip" type="info">复制数据</Button>
            <Button @click="CopyAttachmentsToClip" v-if="images.length > 0 || files.length > 0">复制附件信息</Button>
          </div>
          </div>
          <div class="flex-wrap flex-center pdf-export" style="flex:1;min-height:0;background:#fff;position:relative;overflow-y:auto;padding:10px;">
            <Input
              type="textarea"
              :value="aiText"
              :rows="23"
              style="width:100%;height:100%;display:block;font-family:inherit;white-space:pre-wrap;"
              placeholder="点击「获取数据」后此处显示层级数据"
              readonly
            />
          </div>
        </div>
      </div>
      <BaseLoadingModal v-model="loading" />
    </div>
</template>

<script>
// 预设提示词：多项目自建任务对比，统计高频任务并建议纳入模板
const PRESET_PROMPT_TEMPLATE = `【应用场景】根据多项目的自建任务数据，统计高频任务并给出模版化管理建议。

请先忽略无意义的、测试类的任务（如：测试、试运行、临时、demo、示例、占位等），再基于下方「项目-模块-阶段-工作包-任务」层级数据完成分析：

1. **多项目对比与高频统计**  
   统计在多个项目中重复出现的任务（可按任务名称或业务含义归类），列出高频任务及出现次数/项目数，便于识别共性工作。

2. **建议纳入模版化管理的任务及理由**  
   在以上统计基础上，明确建议纳入通用模板管理的具体任务（或任务类型），并逐条说明理由（如：多项目普遍存在、表述一致、可标准化、便于管控等）。

输出请结构清晰、结论明确，便于后续决策与模板维护。`;

// 层级（与接口字段对应）：
//   ProjectName 项目
//     module    模块
//       stage   阶段
//         workpackage 工作包
//           工作节点   jobNode（叶子，展示为 [序号] jobNode）
const INDENT = '    '; // 每级缩进 4 空格

function normalizeTask(t) {
  return {
    ...t,
    projectName: t.projectName || '未知项目',
    module: t.module || '默认模块',
    stage: t.stage || '',
    workpackage: t.workpackage || '',
    jobNode: t.jobNode || '',
  };
}

// 将任务列表按层级格式化为文本（项目->模块->阶段->工作包->工作节点，任务序号按项目从 1 开始）
function buildHierarchyText(tasks) {
  const normalized = tasks.map(normalizeTask);
  const byProject = {};
  normalized.forEach((task) => {
    const p = task.projectName;
    if (!byProject[p]) byProject[p] = {};
    const mod = task.module;
    if (!byProject[p][mod]) byProject[p][mod] = {};
    const st = task.stage;
    if (!byProject[p][mod][st]) byProject[p][mod][st] = {};
    const wp = task.workpackage;
    if (!byProject[p][mod][st][wp]) byProject[p][mod][st][wp] = [];
    byProject[p][mod][st][wp].push(task);
  });

  const lines = [];
  Object.keys(byProject).sort().forEach((projectName) => {
    let projectTaskIndex = 0;
    lines.push(projectName);
    const byMod = byProject[projectName];
    Object.keys(byMod).sort().forEach((module) => {
      lines.push(INDENT + module);
      const byStage = byMod[module];
      Object.keys(byStage).sort().forEach((stage) => {
        lines.push(INDENT + INDENT + (stage || '(未分组)'));
        const byWp = byStage[stage];
        Object.keys(byWp).sort().forEach((workpackage) => {
          lines.push(INDENT + INDENT + INDENT + (workpackage || '(未分组)'));
          byWp[workpackage].forEach((task) => {
            projectTaskIndex += 1;
            lines.push(INDENT + INDENT + INDENT + INDENT + `[${projectTaskIndex}] ${task.jobNode}`);
          });
        });
      });
    });
  });
  return lines.join('\n');
}

export default {
  data() {
    return {
      platform: 'pmis',
      platforms: [{
        key: 'pmis',
        name: '项管',
      }, {
        key: 'jlis',
        name: '监理',
      }, {
        key: 'jgis',
        name: '监管',
      }],
      projects: [],
      selectedProjects: [],
      tasks: [],
      aiText: '',
      userText: PRESET_PROMPT_TEMPLATE,
      loading: false,
      images: [],
      files: [],
      extractForm: false,
      onlyQuestion: false,
    };
  },
  mounted() {
    this.$api.afterLogin(()=>{
      this.getProjects();
    });
  },
  methods: {
    getProjects() {
      this.$api.get('logined_zzl/projects?q=all').then((res)=>{
        this.projects = res.data.data || [];
      });
    },
    getProjectData() {
      this.loading = true;
      const params = {
        platform: this.platform,
      };
      if (this.selectedProjects && this.selectedProjects.length > 0) {
        params.projects = this.selectedProjects;
      }
      this.$api.post('logined_zzl/get_project_untemplated_tasks', params).then((res)=>{
        this.tasks = res.data.data || [];
        this.cleanData();
      }).catch((e)=>{
        this.Error('获取数据失败');
        console.error(e);
      }).finally(()=>{
        this.loading = false;
      });
    },
    cleanData() {
      if (!this.tasks || this.tasks.length === 0) {
        this.aiText = '暂无数据';
        this.images = [];
        this.files = [];
        return;
      }
      this.aiText = buildHierarchyText(this.tasks);
    },
    applyPresetPrompt() {
      this.userText = PRESET_PROMPT_TEMPLATE;
      this.Success('已应用预设提示词');
    },
    async CopyToClip() {
      const text = this.userText + (this.userText ? '\n\n' : '') + this.aiText;
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
        }
        this.Success('复制成功');
        return true;
      } catch (err) {
        console.error('复制失败:', err);
        this.Error('复制失败');
        return false;
      }
    },
    async CopyAttachmentsToClip() {
      const text = this.images.map((v)=>`![${v.name || '图片'}](${v.url || v})`).join('\n') + this.files.map((v)=>`[${v.name || '附件'}](${v.url || v})`).join('\n');
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        }
        this.Success('复制成功');
        return true;
      } catch (err) {
        console.error('复制失败:', err);
        this.Error('复制失败');
        return false;
      }
    },
  },
};
</script>

<style>
.image-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5px;
  width: 200px;
  height: 170px;
}
.image-container img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.image-label{
  font-size: 12px;
  color: #666;
  text-align: center;
}

</style>
